import {
  CreateCashBackMembershipData,
  UpdateCashBackMembershipData,
} from '@features/membership/services/membership-api/membership-api.service';
import { Action } from '@ngrx/store';
import { HttpError, Membership } from '@rd/types';

export enum MembershipActionTypes {
  LOAD_MEMBERSHIPS = '[Programs] Load Memberships',
  LOAD_MEMBERSHIPS_SUCCESS = '[Programs] Load Memberships Success',
  LOAD_MEMBERSHIPS_FAIL = '[Programs] Load Memberships Fail',
  CREATE_CASHBACK_MEMBERSHIP = '[Programs] Create RedeemCash Membership',
  CREATE_MEMBERSHIP_SUCCESS = '[Programs] Create RedeemCash Membership Success',
  CREATE_MEMBERSHIP_FAIL = '[Programs] Create RedeemCash Membership Fail',
  UPDATE_MEMBERSHIP = '[Programs] Update RedeemCash Membership',
  UPDATE_MEMBERSHIP_SUCCESS = '[Programs] Update RedeemCash Membership Success',
  UPDATE_MEMBERSHIP_FAIL = '[Programs] Update RedeemCash Membership Fail',
  CLEAR_CREATE_AND_UPDATE_MEMBERSHIP_ERRORS = '[Programs] Clear Create and Update RedeemCash Membership Errors',
}

export class LoadMemberships implements Action {
  readonly type = MembershipActionTypes.LOAD_MEMBERSHIPS;
}

export class LoadMembershipsSuccess implements Action {
  readonly type = MembershipActionTypes.LOAD_MEMBERSHIPS_SUCCESS;

  constructor(public payload: Membership[]) {}
}

export class LoadMembershipsFail implements Action {
  readonly type = MembershipActionTypes.LOAD_MEMBERSHIPS_FAIL;

  constructor(public payload: HttpError) {}
}

export class CreateMembership implements Action {
  readonly type = MembershipActionTypes.CREATE_CASHBACK_MEMBERSHIP;

  constructor(public payload: CreateCashBackMembershipData) {}
}

export class CreateMembershipSuccess implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS;

  constructor(public payload: Membership) {}
}

export class CreateMembershipFail implements Action {
  readonly type = MembershipActionTypes.CREATE_MEMBERSHIP_FAIL;

  constructor(public payload: HttpError) {}
}

export class UpdateMembership implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP;

  constructor(
    public payload: {
      updateMembershipData: UpdateCashBackMembershipData;
      isOverlapping?: true;
    },
  ) {}
}

export class UpdateMembershipSuccess implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS;

  constructor(public payload: Membership) {}
}

export class UpdateMembershipFail implements Action {
  readonly type = MembershipActionTypes.UPDATE_MEMBERSHIP_FAIL;

  constructor(public payload: HttpError) {}
}

export class ClearCreateAndUpdateMembershipErrors implements Action {
  readonly type =
    MembershipActionTypes.CLEAR_CREATE_AND_UPDATE_MEMBERSHIP_ERRORS;

  constructor() {}
}

export type MembershipActions =
  | LoadMemberships
  | LoadMembershipsSuccess
  | LoadMembershipsFail
  | CreateMembership
  | CreateMembershipSuccess
  | CreateMembershipFail
  | UpdateMembership
  | UpdateMembershipSuccess
  | UpdateMembershipFail
  | ClearCreateAndUpdateMembershipErrors;
